import { creating, exist, Id } from '@campaign-portal/namespace/common/id';
import { TaskStatus } from '@campaign-portal/namespace/common/enums';
import { EdrRerating } from '@campaign-portal/namespace/entities/edr/specs';
import { FilterInterval } from '@campaign-portal/namespace/common/rpc.params';

export interface EdrReratingInfo {
	total: number;
	changed: number;
	clientRevenue: { before: number; after: number };
	vendorCost: { before: number; after: number };
	margin: { before: number; after: number };
}

export interface EdrReratingEntityConfig<ID = exist | creating> extends Partial<EdrRerating<ID>> {
	id: ID;
	createdBy?: string | null;
}

export class EdrReratingEntity<ID = exist | creating> implements EdrRerating<ID> {
	id: ID;
	name: string;
	status: TaskStatus;
	subscriptionsIds: Id<exist>[];
	vendorProductsIds: Id<exist>[];
	countryNetworkList: Id<exist>[];
	period: FilterInterval<string>;
	info?: EdrReratingInfo;
	creationDate?: string | null;
	lastUpdated?: string | null;
	createdBy?: string | null;

	constructor(config: EdrReratingEntityConfig<ID>) {
		this.id = config.id;
		this.name = config.name ?? '';
		this.status = config.status ?? TaskStatus.WAITING;
		this.subscriptionsIds = config.subscriptionsIds ?? [];
		this.vendorProductsIds = config.vendorProductsIds ?? [];
		this.countryNetworkList = config.countryNetworkList ?? [];
		this.period = config.period ?? { Start: '', End: '' };
		this.info = config.info;
		this.creationDate = config.creationDate;
		this.lastUpdated = config.lastUpdated;
		this.createdBy = config.createdBy;
	}

	canStart(): boolean {
		return this.status === TaskStatus.NEW;
	}

	canCancel(): boolean {
		return this.status === TaskStatus.WAITING;
	}

	canRestart(): boolean {
		return this.status === TaskStatus.CANCELLED || this.status === TaskStatus.FAILED;
	}

	isCancelledAuto(): boolean {
		return this.status === TaskStatus.CANCELLED && this.createdBy === 'AUTO';
	}
}
